import { routing } from "@/i18n/routing";

/**
 * Helper function to strip locale prefix from callback URL
 * This is needed when using i18n-aware router from next-intl
 * since it automatically adds the current locale prefix
 */
export const stripLocaleFromPath = (path: string): string => {
  const locales = routing.locales;
  for (const locale of locales) {
    const localePrefix = `/${locale}/`;
    if (path.startsWith(localePrefix)) {
      return path.substring(localePrefix.length - 1); // Keep the leading slash
    }
    // Handle case where path is just the locale (e.g., "/en")
    if (path === `/${locale}`) {
      return "/";
    }
  }
  return path;
};
